"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Rule = require("./Rule");

var _Rule2 = _interopRequireDefault(_Rule);

var _Error = require("./Error");

var _Error2 = _interopRequireDefault(_Error);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Validation = function () {
    function Validation() {
        _classCallCheck(this, Validation);

        this.errors = [];
        this.fields = [];
        this.verdict = {};
    }

    /**
     * Alias for the add method in the Rule class.
     *
     * @param {String} rule
     * @param {Function} validator
     */


    _createClass(Validation, [{
        key: "getErrors",


        /**
         * Get all errors for a given field (if specified, else get
         * all errors for all fields).
         *
         * @param {String=} field
         * @returns {Array}
         */
        value: function getErrors(field) {
            if (!field) {
                return this.errors;
            }

            if (this.fields.indexOf(field) === -1) {
                return [];
            }

            return this.verdict[field].errors;
        }

        /**
         * Get the first error of the field, if exists, else return
         * an empty string.
         *
         * @param {String} field
         * @returns {String}
         */

    }, {
        key: "getError",
        value: function getError(field) {
            if (this.fields.indexOf(field) === -1 || !this.verdict.hasOwnProperty(field)) {
                return '';
            }
            return this.verdict[field].errors[0] || '';
        }

        /**
         * Test the given input against the given rules.
         *
         * @param {Object} input
         * @param {Object} rules
         * @param {Object=} messages
         * @returns {Validation}
         */

    }, {
        key: "validate",
        value: function validate(input, rules, messages) {
            var validation = {};
            this.fields = Object.keys(input);

            for (var rule in rules) {
                if (!rules.hasOwnProperty(rule)) {
                    continue;
                }

                if (!input.hasOwnProperty(rule)) {
                    continue;
                }

                // Add parsed rules for input inside validation object.
                validation[rule] = _Rule2.default.parse(rules[rule], rule);
            }

            var verdict = {};

            // Run tests for each input field.
            for (var field in validation) {
                if (!validation.hasOwnProperty(field)) {
                    continue;
                }

                for (var _rule in validation[field]) {
                    if (!validation[field].hasOwnProperty(_rule)) {
                        continue;
                    }

                    if (!verdict.hasOwnProperty(field)) {
                        verdict[field] = {};
                    }

                    var message = null;

                    if (messages && messages.hasOwnProperty(field) && messages[field].hasOwnProperty(_rule)) {
                        message = messages[field][_rule];
                    }

                    // Add result of test to verdict object.
                    verdict[field][_rule] = _Rule2.default.test(_rule, validation[field][_rule], input[field], message);
                }

                verdict[field].errors = _Error2.default.getErrors(verdict[field]);
            }

            this.errors = _Error2.default.getAllErrors(verdict);
            this.verdict = verdict;

            return this;
        }
    }], [{
        key: "addRule",
        value: function addRule(rule, validator) {
            _Rule2.default.add(rule, validator);
        }
    }]);

    return Validation;
}();

exports.default = Validation;